<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright" style="text-align:left"><span>Copyright © 1978, 1980, 1981, 1982, 1984, 1985, 1986 by Penelope Lively</span></p>
<p class="linespace">
</p><p class="copyright" style="text-align:justify"><span>All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Any members of educational institutions wishing to photocopy part or all of the work for classroom use, or publishers who would like to obtain permission to include the work in an anthology, should send their inquiries to Grove/Atlantic, Inc., 841 Broadway, New York, NY 10003.</span></p>
<p class="linespace">
</p><p class="copyright" style="text-align:left"><span><i>First published in 1986 by William Heinemann Ltd., London</i></span></p>
<p class="copyright" style="text-align:left"><span><i>Printed in the United States of America</i></span></p>
<p class="linespace">
</p><p class="copyright" style="text-align:left"><span><span class="fsc">FIRST GROVE PRESS PAPERBACK EDITION</span></span></p>
<p class="linespace">
</p><p class="copyright" style="text-align:left"><span>Library of Congress Cataloging-in-Publication Data</span></p>
<p class="linespace">
</p><p class="copyright" style="text-align:left"><span>Lively, Penelope, 1933–</span></p>
<p class="copyright" style="text-align:left"><span>      Pack of cards and other stories / Penelope Lively.</span></p>
<p class="copyright" style="text-align:left"><span>      “First published in 1986 by William Heinemann Ltd., London”—T.p. verso.</span></p>
<p class="copyright" style="text-align:left"><span>      ISBN 9780802197351</span></p>
<p class="copyright" style="text-align:left"><span>      I. Title.</span></p>
<p class="copyright" style="text-align:left"><span>PR6062.I89P3 1989</span></p>
<p class="copyright" style="text-align:left"><span>823′.914—dcl9                   89-1851</span></p>
<p class="linespace">
</p><p class="copyright" style="text-align:left"><span>Grove Press</span></p>
<p class="copyright" style="text-align:left"><span>841 Broadway</span></p>
<p class="copyright" style="text-align:left"><span>New York, NY 10003</span></p>
<p class="linespace">
</p><p class="copyright" style="text-align:left"><span>99 00 01 02  10 9 8 7 6 5 4 3 2 1</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004_Copyright.vue?7211f07a